import React, {useState, useEffect} from 'react';
import {View, FlatList, StyleSheet} from 'react-native';
import {Modal, Portal, Text, Checkbox, Button} from 'react-native-paper';
import {useTranslation} from 'react-i18next';
import {useInventoryStore} from '../../store/useInventoryStore';
import {colors, spacing} from '../../theme';

const SelectSizeModal = ({visible, selectedIds, onDismiss, onSave}) => {
  const {t} = useTranslation();
  const {readymadeSizes, fetchReadymadeSizes} = useInventoryStore();
  const [selected, setSelected] = useState(new Set(selectedIds || []));

  useEffect(() => {
    if (visible) {
      fetchReadymadeSizes();
      setSelected(new Set(selectedIds || []));
    }
  }, [visible, selectedIds, fetchReadymadeSizes]);

  const toggleSize = (id) => {
    setSelected(prev => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  const renderItem = ({item}) => (
    <View style={styles.row}>
      <Checkbox
        status={selected.has(item.id) ? 'checked' : 'unchecked'}
        onPress={() => toggleSize(item.id)}
        color={colors.primary}
      />
      <Text style={styles.sizeName} onPress={() => toggleSize(item.id)}>{item.name}</Text>
    </View>
  );

  return (
    <Portal>
      <Modal visible={visible} onDismiss={onDismiss} contentContainerStyle={styles.modal}>
        <Text style={styles.title}>{t('inventory.selectSizes')}</Text>

        <FlatList
          data={readymadeSizes}
          renderItem={renderItem}
          keyExtractor={item => String(item.id)}
          style={styles.list}
        />

        <View style={styles.actions}>
          <Button mode="outlined" onPress={onDismiss} style={styles.actionBtn}>
            {t('common.cancel')}
          </Button>
          <Button mode="contained" onPress={() => onSave([...selected])} style={styles.actionBtn}>
            {t('common.save')}
          </Button>
        </View>
      </Modal>
    </Portal>
  );
};

const styles = StyleSheet.create({
  modal: {
    backgroundColor: colors.surface,
    margin: spacing.md,
    padding: spacing.md,
    borderRadius: 15,
    maxHeight: '70%',
  },
  title: {fontSize: 18, fontWeight: '600', marginBottom: spacing.sm, color: colors.text},
  list: {maxHeight: 300},
  row: {flexDirection: 'row', alignItems: 'center', paddingVertical: spacing.xs},
  sizeName: {fontSize: 16, color: colors.text, marginLeft: spacing.xs},
  actions: {flexDirection: 'row', justifyContent: 'flex-end', gap: spacing.sm, marginTop: spacing.md},
  actionBtn: {minWidth: 100, borderRadius: 10, paddingHorizontal: 10},
});

export default SelectSizeModal;
